import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Container from "../../hoc/Container";
import { tgIcon } from "../../../images";
import SteamTopUpWidget from "../../components/steam/SteamTopUpWidget";
import {
  STEAM_TOPUP_FAQ,
  steamTopupJsonLd,
} from "./steamTopupSeo";

const SUPPORT_URL = process.env.REACT_APP_SUPPORT_URL;

function SteamPageNew() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    window.ym(93997310, "hit", "/steam", {
      params: {
        title: "Пополнение Steam",
        referer: "https://trendy-eng-shop.ru/",
      },
    });
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    const nodes = steamTopupJsonLd().map((data, index) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.dataset.steamTopupLd = String(index);
      el.text = JSON.stringify(data).replace(/</g, "\\u003c");
      document.head.appendChild(el);
      return el;
    });
    return () => {
      nodes.forEach((el) => el.remove());
    };
  }, []);

  return (
    <Container>
      <section className="content-block mb-2">
        <h1 className="head-1">Пополнение Steam</h1>

        <div className="mb-8 flex flex-col md:flex-row items-start justify-between space-x-2 px-2">
          <div className="w-full md:basis-3/5 flex flex-col items-center justify-center order-1 md:order-2">
            <div className="my-2 w-full steam-widget">
              <SteamTopUpWidget
                initialRub={Number(searchParams.get("amount")) || 0}
                initialKzt={Number(searchParams.get("kzt")) || 0}
              />
            </div>

            <div className="mt-4 text-center">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
                Или купите карты через Telegram или на сайте
              </p>
              <div className="flex flex-wrap items-center justify-center gap-3">
                <div onClick={() => window.ym(93997310, "reachGoal", "tgClickSteam")}>
                  <a
                    href={"https://t.me/trendy_steam_bot?start=ref-001"}
                    className="flex w-40 justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Купить в <img src={tgIcon} alt="Telegram" className=" ml-2" />
                  </a>
                </div>
                <a
                  href="/store/steam"
                  onClick={() => window.ym(93997310, "reachGoal", "siteClickSteamStore")}
                  className="flex w-40 justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  На сайте
                </a>
              </div>
            </div>
          </div>

          <div className="hidden md:flex w-full md:basis-2/5 justify-center items-start order-2 md:order-1 mt-4 md:mt-0">
            <div className="w-full max-w-md md:max-w-none flex justify-center items-start pt-4">
              <img
                className="w-full h-auto rounded-lg hover:shadow-lg hover:shadow-zinc-900 transition-shadow duration-300 cursor-pointer"
                src="/static/images/steampop.png"
                alt="Пополнение Steam на Trendy shop — форма оплаты по логину"
                onClick={() => {
                  const widget = document.querySelector(".steam-widget");
                  if (widget) {
                    widget.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    });
                  }
                  window.ym(93997310, "reachGoal", "steampopClickToWidget");
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <article className="content-block text-justify">
        <section id="how-to-find-login" className="my-8">
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-700 rounded-lg p-6 shadow-lg space-y-6">
            <div className="space-y-1.5">
              <h2 className="text-center text-2xl font-bold text-gray-800 dark:text-white">
                Как найти свой логин
              </h2>
              <p className="text-center text-gray-700 dark:text-gray-200 text-lg">
                <strong>Логин</strong> — это то, что вы вводите для входа в Steam, а не никнейм.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-3 text-center">
                На компьютере
              </h3>
              <div className="flex flex-col lg:flex-row items-start gap-6">
                <div className="w-full lg:w-[58%]">
                  <img
                    src="/static/images/steam-login.png"
                    alt="Как найти логин Steam на компьютере: меню Об аккаунте"
                    className="w-full h-auto rounded-lg shadow-xl"
                  />
                </div>
                <div className="w-full lg:w-[42%]">
                  <div className="bg-white dark:bg-gray-600 rounded-lg p-5 shadow-sm text-left">
                    <p className="text-gray-700 dark:text-gray-200 text-lg leading-relaxed mb-4">
                      Перепроверить логин на ПК можно так:
                    </p>
                    <ol className="text-gray-700 dark:text-gray-200 space-y-3">
                      <li className="flex items-start">
                        <span className="bg-blue-500 text-white rounded-full w-7 h-7 flex flex-shrink-0 items-center justify-center text-sm font-bold mr-3">1</span>
                        <span className="text-lg leading-7">Сверху справа — ваш ник</span>
                      </li>
                      <li className="flex items-start">
                        <span className="bg-blue-500 text-white rounded-full w-7 h-7 flex flex-shrink-0 items-center justify-center text-sm font-bold mr-3">2</span>
                        <span className="text-lg leading-7">Нажимаем на него</span>
                      </li>
                      <li className="flex items-start">
                        <span className="bg-blue-500 text-white rounded-full w-7 h-7 flex flex-shrink-0 items-center justify-center text-sm font-bold mr-3">3</span>
                        <span className="text-lg leading-7 font-bold">Об аккаунте: ВАШ ЛОГИН</span>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-4 text-center">
                На телефоне
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                  {
                    n: 1,
                    src: "/static/images/steam-login-mob-1.png",
                    text: "Нажмите на иконку вашего профиля в верхней части экрана.",
                  },
                  {
                    n: 2,
                    src: "/static/images/steam-login-mob-2.png",
                    text: "Уже на этом экране виден ваш логин — внизу, в пункте «Сменить аккаунт». Наверху, рядом с аватаркой — никнейм, вам он не нужен.",
                  },
                  {
                    n: 3,
                    src: "/static/images/steam-login-mob-3.png",
                    text: "Можно перейти в раздел «Об аккаунте». Там логин будет на видном месте, его можно будет скопировать.",
                  },
                ].map((step) => (
                  <div key={step.n} className="flex flex-col items-center text-center">
                    <div className="flex items-start gap-2 mb-3 w-full max-w-xs mx-auto text-left">
                      <span className="bg-blue-500 text-white rounded-full w-7 h-7 flex flex-shrink-0 items-center justify-center text-sm font-bold">
                        {step.n}
                      </span>
                      <p className="text-gray-700 dark:text-gray-200 text-base leading-snug">
                        {step.text}
                      </p>
                    </div>
                    <img
                      src={step.src}
                      alt={`Как найти логин Steam на телефоне, шаг ${step.n}`}
                      className="w-full max-w-[280px] h-auto rounded-xl shadow-xl border border-gray-200 dark:border-gray-600"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section id="steam-how" className="my-5">
          <h2 className="my-2 text-center text-2xl">Как пополнить</h2>
          <ol className="dark-text my-3 w-full list-decimal pl-8 text-gray-700 space-y-2">
            <li>Введите логин Steam и сумму пополнения в рублях.</li>
            <li>Подтвердите логин и оплатите по СБП.</li>
            <li>Дождитесь зачисления на кошелёк — обычно до 10 минут.</li>
          </ol>
        </section>

        <section id="steam-description" className=" my-5 ">
          <h2 className="my-2 text-center text-2xl overline decoration-sky-500">
            Для каких аккаунтов
          </h2>
          <p className=" dark-text my-3 w-full indent-4 text-gray-700">
            Можно пополнять аккаунты Russia, Belarus, Ukraine, Armenia, Azerbaijan, Georgia,
            Kazakhstan, Kyrgyzstan, Moldova, Tajikistan, Turkmenistan and Uzbekistan.
            Вы вводите сумму в рублях — в Steam для российских аккаунтов зачислится ровно эта
            сумма. Эквивалент в долларах и тенге ниже — примерный курс для удобства.
          </p>
          <p className=" dark-text my-3 w-full text-sm text-gray-500 dark:text-gray-400">
            * — примерный курс: доллары и тенге из курса Steam, за время операции может измениться.
          </p>
        </section>

        <section id="steam-psk" className="my-5">
          <h2 className="my-2 text-center text-2xl">
            ПСК — персональное снижение комиссии
          </h2>
          <p className="dark-text my-3 w-full indent-4 text-gray-700">
            ПСК (персональное снижение комиссии) уменьшает процент комиссии за услугу пополнения, а не сумму зачисления в Steam.
            Скидка привязана к логину Steam и считается по сумме успешных пополнений
            (сколько рублей реально зачислилось в Steam).
          </p>
          <ul className="dark-text my-3 w-full list-disc pl-8 text-gray-700 space-y-1">
            <li>Первый заказ — без скидки (0% ПСК).</li>
            <li>За каждые полные 1&nbsp;000&nbsp;₽ успешных пополнений — +0,1% ПСК.</li>
            <li>Максимум — 3% ПСК (начиная с 30&nbsp;000&nbsp;₽ накопленного).</li>
            <li>Учитываются только успешно оплаченные и выполненные заказы; текущий заказ до оплаты не входит.</li>
            <li>История считается по сохранённым заказам с этим логином (порядка 3 лет по сроку хранения данных).</li>
          </ul>
        </section>

        <section className=" my-5">
          <h2 className="my-2 text-center text-2xl">Особенности</h2>
          <p className=" dark-text my-3 w-full indent-4 text-gray-700">
            Пополнение обычно занимает меньше 10 минут, но если аккаунт не пополнился в течение 2 часов, то пишите в{" "}
            {SUPPORT_URL ? (
              <a href={SUPPORT_URL} className="text-blue-700 dark:text-indigo-400" target="_blank" rel="noreferrer">
                техподдержку
              </a>
            ) : (
              "техподдержку"
            )}
            .
          </p>
          <p className=" dark-text my-3 w-full indent-4 text-gray-700">
            Это не коды пополнения: вы вводите логин Steam и сумму в рублях, система показывает
            стоимость к оплате и примерный эквивалент в долларах и тенге. Подарочные карты — в{" "}
            <a href="https://t.me/trendy_steam_bot?start=ref-001" className="text-blue-700 dark:text-indigo-400" target="_blank" rel="noreferrer">
              Telegram-боте
            </a>
            {" "}или на{" "}
            <a href="/store/steam" className="text-blue-700 dark:text-indigo-400">
              странице кодов Steam
            </a>
            .
          </p>
        </section>

        <section id="steam-faq" className="my-8">
          <h2 className="my-2 text-center text-2xl">Вопросы и ответы</h2>
          <div className="space-y-4 px-2">
            {STEAM_TOPUP_FAQ.map((item) => (
              <div key={item.q}>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">
                  {item.q}
                </h3>
                <p className="text-gray-700 dark:text-gray-300">{item.a}</p>
              </div>
            ))}
          </div>
        </section>

        <nav className="my-6 px-2 text-center text-sm text-gray-600 dark:text-gray-400" aria-label="Связанные разделы">
          <a href="/store/steam" className="text-blue-700 dark:text-indigo-400 mx-2">Коды Steam</a>
          ·
          <a href="/steam/shop" className="text-blue-700 dark:text-indigo-400 mx-2">Магазин Steam</a>
          ·
          <a href="/steam-discount" className="text-blue-700 dark:text-indigo-400 mx-2">Скидки Steam</a>
        </nav>
      </article>
    </Container>
  );
}

export default SteamPageNew;
